import { writeFilterMemorySnapshot } from './filterMemory';

// 流程（打印/详情等）跳转前调用：整包备份 vuex 中的筛选记忆，供整页刷新后恢复
export function backupFilterMemory({ state }) {
  writeFilterMemorySnapshot(state);
}

export function PK_LIST({ commit }, data) {
  commit('PK_LIST', data);
}

export function CONFIRM_PK_LIST({ commit }, data) {
  commit('CONFIRM_PK_LIST', data);
}


export function CHANGE_PK_LIST({ commit }, row) {
  commit('CHANGE_PK_LIST', row);
}

// ------------------------------------------记住密码
export function SET_ACC_INFO({ commit }, dataInfo) {
  commit('SET_ACC_INFO', dataInfo);
}
// ------------------------------------------采买单
export function SET_CMD_INFO_CONDITION({ commit }, dataInfo) {
  commit('SET_CMD_INFO_CONDITION', dataInfo);
}
// 进销存
export function SET_DEPOSIT_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_DEPOSIT_DATA_CONDITION', dataInfo);
}
// --------------------------------------------结算管理
// --------------------------------------------自录客户
export function SET_NEW_ORDER_SEARCH_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_NEW_ORDER_SEARCH_DATA_CONDITION', dataInfo);
}
// -------------------------------------------出库
export function SET_STOCK_OUT_CONDITION({ commit }, dataInfo) {
  commit('SET_STOCK_OUT_CONDITION', dataInfo);
}
export function SET_STOCK_IN_CONDITION({ commit }, dataInfo) {
  commit('SET_STOCK_IN_CONDITION', dataInfo);
}
export function SET_SALE_PRICING_CONDITION({ commit }, dataInfo) {
  commit('SET_SALE_PRICING_CONDITION', dataInfo);
}
// -------------------------------------------供应商结算
export function SET_READY_SEARCH_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_READY_SEARCH_DATA_CONDITION', dataInfo);
}
// -------------------------------------------团餐客户结算
export function SET_ORDER_LIST_SEARCH_CONDITION({ commit }, dataInfo) {
  commit('SET_ORDER_LIST_SEARCH_CONDITION', dataInfo);
}
// ---------------------------------------自录客户结算列表
export function SET_ORDER_LIST_CONDITION({ commit }, dataInfo) {
  commit('SET_ORDER_LIST_CONDITION', dataInfo);
}
// ---------------------------------------团餐结算列表
export function SET_TC_ORDER_LIST_CONDITION({ commit }, dataInfo) {
  commit('SET_TC_ORDER_LIST_CONDITION', dataInfo);
}
// ---------------------------------------供应商结算列表
export function SET_GYS_ORDER_LIST_CONDITION({ commit }, dataInfo) {
  commit('SET_GYS_ORDER_LIST_CONDITION', dataInfo);
}

// ----------------------------销售订单
export function SET_ENTRY_SEARCH_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_ENTRY_SEARCH_DATA_CONDITION', dataInfo);
}
// ----------------------------销售订单--待确认
export function SET_XMD_CONFIRM_SEARCH_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_XMD_CONFIRM_SEARCH_DATA_CONDITION', dataInfo);
}
// ----------------------------销售订单--待确认
export function SET_CONFIRM_SEARCH_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_CONFIRM_SEARCH_DATA_CONDITION', dataInfo);
}
// ----------------------------销售订单--历史
export function SET_HISTORY_SEARCH_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_HISTORY_SEARCH_DATA_CONDITION', dataInfo);
}
export function SET_SAVE_OTHER_PANENAME({ commit }, dataInfo) {
  commit('SET_SAVE_OTHER_PANENAME', dataInfo);
}
// ----------------------------销售订单--全部
export function SET_ALL_SEARCH_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_ALL_SEARCH_DATA_CONDITION', dataInfo);
}
// ----------------------------销售订单--订单查询
export function SET_SERACH_SELL_ORDER_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_SERACH_SELL_ORDER_DATA_CONDITION', dataInfo);
}

// ----------------------------采购订单--待送
export function SET_NEWORDER_SEARCH_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_NEWORDER_SEARCH_DATA_CONDITION', dataInfo);
}
// ----------------------------采购订单--历史
export function SET_NEWORDER_HISTORY_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_NEWORDER_HISTORY_DATA_CONDITION', dataInfo);
}
// ----------------------------报表--出库单
export function SET_HISTORY_OUT_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_HISTORY_OUT_DATA_CONDITION', dataInfo);
}
export function SET_HISTORY_IN_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_HISTORY_IN_DATA_CONDITION', dataInfo);
}
// ----------------------------供应商管理-----新增产品
export function SET_GYS_ADD_ORDER_CONDITION({ commit }, dataInfo) {
  commit('SET_GYS_ADD_ORDER_CONDITION', dataInfo);
}
// ----------------------------库存状态
export function SET_SHOW_KC({ commit }, dataInfo) {
  commit('SET_SHOW_KC', dataInfo);
}
// ----------------------------面板状态
export function SET_SAVE_PANENAME({ commit }, dataInfo) {
  commit('SET_SAVE_PANENAME', dataInfo);
}
export function SET_SAVE_STOCKLIST({ commit }, dataInfo) {
  commit('SET_SAVE_STOCKLIST', dataInfo);
}
export function SET_SAVE_DSORDER_LIST({ commit }, dataInfo) {
  commit('SET_SAVE_DSORDER_LIST', dataInfo);
}
export function SET_SAVE_QUALIFIC_LIST({ commit }, dataInfo) {
  commit('SET_SAVE_QUALIFIC_LIST', dataInfo);
}
// ----------------------------报表--销售退货单
export function 设置销售退货单存储数据({ commit }, dataInfo) {
  commit('设置销售退货单存储数据', dataInfo);
}
export function 设置第三方供货关系管理存储数据({ commit }, dataInfo) {
  commit('设置第三方供货关系管理存储数据', dataInfo);
}
export function 设置分拣差异查询存储数据({ commit }, data) {
  commit('设置分拣差异查询存储数据', data);
}

export function 设置销售订单待送订单存储数据({ commit }, dataInfo) {
  commit('设置销售订单待送订单存储数据', dataInfo);
}

export function 设置采购报表存储数据({ commit }, dataInfo) {
  commit('设置采购报表存储数据', dataInfo);
}

export function 设置进货台账存储数据({ commit }, dataInfo) {
  commit('设置进货台账存储数据', dataInfo);
}
// 销售报表 时间
export function TAB_SALES_DATE({ commit }, dataInfo) {
  commit('TAB_SALES_DATE', dataInfo);
}
// 销售订单 ----》打印标签
export function S_PRINT_ALL({ commit }, dataInfo) {
  commit('S_PRINT_ALL', dataInfo);
}
// 报表 -------》每日剩余库存表
export function DAILYINVENTORY_ALL({ commit }, dataInfo) {
  commit('DAILYINVENTORY_ALL', dataInfo);
}
// 报表 -------》盘库盈亏表
export function PROFITLOSSTABLE_ALL({ commit }, dataInfo) {
  commit('PROFITLOSSTABLE_ALL', dataInfo);
}
// 报表 -------》销售退库单
export function RETURNWAREHOUSE_ALL({ commit }, dataInfo) {
  commit('RETURNWAREHOUSE_ALL', dataInfo);
}
// 报表 -------》销售退货单
export function RETURNGOODS_ALL({ commit }, dataInfo) {
  commit('RETURNGOODS_ALL', dataInfo);
}
// 报表 -------》采购退货单
export function RETURNPRODUCT_ALL({ commit }, dataInfo) {
  commit('RETURNPRODUCT_ALL', dataInfo);
}
// 报表 -------》销售报表
export function SALESSTATEMENTS_ALL({ commit }, dataInfo) {
  commit('SALESSTATEMENTS_ALL', dataInfo);
}
// 报表 -------》毛利报表
export function GROSSPROFIT_ALL({ commit }, dataInfo) {
  commit('GROSSPROFIT_ALL', dataInfo);
}
// 报表 -------》采购报表
export function PURCHASE_ALL({ commit }, dataInfo) {
  commit('PURCHASE_ALL', dataInfo);
}
// 报表 -------》进销存报表
export function TOTALDEPOSITPURCHASE_ALL({ commit }, dataInfo) {
  commit('TOTALDEPOSITPURCHASE_ALL', dataInfo);
}
// 报表 -------》客户毛利表
export function TCGROSSPROFIT_ALL({ commit }, dataInfo) {
  commit('TCGROSSPROFIT_ALL', { dataInfo });
}
// 报表 -------》销售退货单
export function SELLORDERRETURN_ALL({ commit }, dataInfo) {
  commit('SELLORDERRETURN_ALL', { dataInfo });
}
// 报表 -------》采购价格变化趋势
export function PRICECHANGECHART_ALL({ commit }, dataInfo) {
  commit('PRICECHANGECHART_ALL', { dataInfo });
}
// 报表 -------》商品销售排行
export function PRODUCTRANKLIST_ALL({ commit }, dataInfo) {
  commit('PRODUCTRANKLIST_ALL', { dataInfo });
}
// 报表 -------》总仓单品毛利表
export function SINGLERANGE_ALL({ commit }, dataInfo) {
  commit('SINGLERANGE_ALL', { dataInfo });
}
// ---------------------------------------------------------采买单
export function SET_PURCHASE_SEARCH({ commit }, dataInfo) {
  commit('SET_PURCHASE_SEARCH', dataInfo);
}
// ---------------------------------------------------------分菜单管理
export function SET_SORT_SEARCH({ commit }, dataInfo) {
  commit('SET_SORT_SEARCH', dataInfo);
}
// ---------------------------------------------------------领料单
export function SET_SAVE_PICKING_DOC({ commit }, dataInfo) {
  commit('SET_SAVE_PICKING_DOC', dataInfo);
}
// ------------------------------------------------------------生产领料单
export function SET_SAVE_PRO_PICKING_DOC({ commit }, dataInfo) {
  commit('SET_SAVE_PRO_PICKING_DOC', dataInfo);
}
// ------------------------------------------------------------生产出库
export function SET_SAVE_PRO_WAREHOUSING({ commit }, dataInfo) {
  commit('SET_SAVE_PRO_WAREHOUSING', dataInfo);
}
// ------------------------------------------------------------生产出库单
export function SET_SAVE_PRO_RECEIPT({ commit }, dataInfo) {
  commit('SET_SAVE_PRO_RECEIPT', dataInfo);
}
// ---------------------------------------------------------客户列表
export function SET_SAVE_CUSTOMER_LIST({ commit }, dataInfo) {
  commit('SET_SAVE_CUSTOMER_LIST', dataInfo);
}
// ----------------------------------------------------------供应商管理
export function SET_SUPPLIER_LIST({ commit }, dataInfo) {
  commit('SET_SUPPLIER_LIST', dataInfo);
}
// ---------------------------------------------------------生产配置
export function SET_PRODUCTION_LIST({ commit }, dataInfo) {
  commit('SET_PRODUCTION_LIST', dataInfo);
}
// --------------------------------------------------------出库汇总单
export function SET_TOTAL_OUT_DOC_LIST({ commit }, dataInfo) {
  commit('SET_TOTAL_OUT_DOC_LIST', dataInfo);
}
// 仓库管理->盘库筛选条件记录
export function SET_INVENTORY_SEARCH({ commit }, dataInfo) {
  commit('SET_INVENTORY_SEARCH', dataInfo);
}
// 人员管理
export function SET_PERSON_MANAGE_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_PERSON_MANAGE_DATA_CONDITION', dataInfo);
}
// 库位
export function SET_POSITION_CONDITION({ commit }, dataInfo) {
  commit('SET_POSITION_CONDITION', dataInfo);
}
// 一类
export function SET_FIRST_CATEGORY_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_FIRST_CATEGORY_DATA_CONDITION', dataInfo);
}
// 二类
export function SET_SECOND_CATEGORY_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_SECOND_CATEGORY_DATA_CONDITION', dataInfo);
}
// 在用SKU管理
export function SET_SKU_USED_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_SKU_USED_DATA_CONDITION', dataInfo);
}
// 采购待确认订单
export function SET_CONFIRM_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_CONFIRM_DATA_CONDITION', dataInfo);
}
// 待确认订单
export function SET_CONFIRM_DATA_CONDITION_S({ commit }, dataInfo) {
  commit('SET_CONFIRM_DATA_CONDITION_S', dataInfo);
}
// WMS-临时仓
export function SET_WMS_TEMPORARYSTOCK_CONDITION({ commit }, dataInfo) {
  commit('SET_WMS_TEMPORARYSTOCK_CONDITION', dataInfo);
}
// WMS-库存预警
export function SET_WMS_STOCKWARNING_CONDITION({ commit }, dataInfo) {
  commit('SET_WMS_STOCKWARNING_CONDITION', dataInfo);
}
// 拣货单界面
export function SET_PICKINGLIST_CONDITION({ commit }, dataInfo) {
  commit('SET_PICKINGLIST_CONDITION', dataInfo);
}
// 价格管理-客户定价复核
export function SET_CUSTOMER_PRICING_REVIEW_CONDITION({ commit }, dataInfo) {
  commit('SET_CUSTOMER_PRICING_REVIEW_CONDITION', dataInfo);
}
// 销售订单管理-销售价复核
export function SET_SALES_PRICE_REVIEW_CONDITION({ commit }, dataInfo) {
  commit('SET_SALES_PRICE_REVIEW_CONDITION', dataInfo);
}
// 产品管理-产品税率-供应商税率设置
export function SET_SUPPLIERTAX_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_SUPPLIERTAX_DATA_CONDITION', dataInfo);
}

// 报表-送货差异表
export function SET_DELIVERY_DISCREPANCY_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_DELIVERY_DISCREPANCY_DATA_CONDITION', dataInfo);
}

// 分拣配送-分拣组管理
export function SET_SORTING_GROUP_MANAGEMENT_CONDITION({ commit }, dataInfo) {
  commit('SET_SORTING_GROUP_MANAGEMENT_CONDITION', dataInfo);
}

// 财务中心-发票列表
export function SET_INVOICE_LIST_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_INVOICE_LIST_DATA_CONDITION', dataInfo);
}

// 分拣配送-周转筐管理
export function SET_TURNOVER_MANAGE_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_TURNOVER_MANAGE_DATA_CONDITION', dataInfo);
}

// 价格管理-销售价格查询
export function SET_SALES_PRICE_INQUIRY_CONDITION({ commit }, dataInfo) {
  commit('SET_SALES_PRICE_INQUIRY_CONDITION', dataInfo);
}
// 价格管理-采购价格查询
export function SET_PURCHASE_PRICE_INQUIRY_CONDITION({ commit }, dataInfo) {
  commit('SET_PURCHASE_PRICE_INQUIRY_CONDITION', dataInfo);
}

// 第三方配送订单-转换订单
export function SET_SUPPLIER_SEND_ORDER_CONDITION({ commit }, dataInfo) {
  commit('SET_SUPPLIER_SEND_ORDER_CONDITION', dataInfo);
}
// 第三方配送订单-历史订单
export function SET_DSHISTORY_ORDER_LIST_CONDITION({ commit }, dataInfo) {
  commit('SET_DSHISTORY_ORDER_LIST_CONDITION', dataInfo);
}
// 第三方配送订单-待送订单
export function SET_DS_ORDER_LIST_CONDITION({ commit }, dataInfo) {
  commit('SET_DS_ORDER_LIST_CONDITION', dataInfo);
}
// 第三方配送订单-待确认订单
export function SET_DS_ORDER_CONFIRM_LIST_CONDITION({ commit }, dataInfo) {
  commit('SET_DS_ORDER_CONFIRM_LIST_CONDITION', dataInfo);
}
// 食品安全-采购品资质下载
export function SET_PURCHASE_QUALIFICATION_DOWNLOAD_LIST({ commit }, dataInfo) {
  commit('SET_PURCHASE_QUALIFICATION_DOWNLOAD_LIST', dataInfo);
}
// 食品安全-采购品资质下载详情
export function SET_PURCHASE_QUALIFICATION_DOWNLOAD_DETAIL_LIST({ commit }, dataInfo) {
  commit('SET_PURCHASE_QUALIFICATION_DOWNLOAD_DETAIL_LIST', dataInfo);
}
// 报表-业务部毛利表
export function SET_BUSINESS_GROSS_PROFIT_TABLE({ commit }, dataInfo) {
  commit('SET_BUSINESS_GROSS_PROFIT_TABLE', dataInfo);
}
// 报表-仓库收发明细表
export function SET_WAREHOUSE_TRANSCEIVER_CONDITION({ commit }, dataInfo) {
  commit('SET_WAREHOUSE_TRANSCEIVER_CONDITION', dataInfo);
}
// 报表-采购部差价表
export function SET_PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION', dataInfo);
}
// 销售订单管理-订单调价申请记录
export function SET_PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_PRICE_ADJUSTMENT_RECORDS_LIST_DATA_CONDITION', dataInfo);
}
// 财务中心-客户结算-供应商客户
export function SET_SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_SUPPLIER_CUSTOMER_SETTLEMENT_DATA_CONDITION', dataInfo);
}

// 销售订单管理-单外订单
export function SET_LOW_PRICE_ORDER_LIST({ commit }, dataInfo) {
  commit('SET_LOW_PRICE_ORDER_LIST', dataInfo);
}

// 报表-项目销售日汇总表
export function SET_PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_PROJECT_SALES_DAILY_SUMMARY_DATA_CONDITION', dataInfo);
}

// 仓库管理-出库验收差异
export function 保存出库验收差异筛选条件({ commit }, dataInfo) {
  commit('保存出库验收差异筛选条件', dataInfo);
}


// 报表-订单产品毛利表
export function 保存订单产品毛利表筛选记忆({ commit }, dataInfo) {
  commit('保存订单产品毛利表筛选记忆', dataInfo);
}
export function 保存供应商快捷结算筛选记忆({ commit }, dataInfo) {
  commit('保存供应商快捷结算筛选记忆', dataInfo);
}

export function SET_ITEM_SALES_SCHEDULE({ commit }, dataInfo) {
  commit('SET_ITEM_SALES_SCHEDULE', dataInfo);
}

export function SET_DS_ORDER_INQUIRY_DATA_CONDITION({ commit }, dataInfo) {
  commit('SET_DS_ORDER_INQUIRY_DATA_CONDITION', dataInfo);
}


export function SET_DELIVERY_TASK_PROGRESS({ commit }, dataInfo) {
  commit('SET_DELIVERY_TASK_PROGRESS', dataInfo);
}

export function SET_STOCK_ENTER_DETAIL({ commit }, dataInfo) {
  commit('SET_STOCK_ENTER_DETAIL', dataInfo);
}

export function SET_DS_UNPRICE_ORDER_DETAIL_CONDITION({ commit }, dataInfo) {
  commit('SET_DS_UNPRICE_ORDER_DETAIL_CONDITION', dataInfo);
}



//////////////////
// WEBPACK FOOTER
// ./store/action.js
// module id = null
// module chunks = 